import React from 'react';
import { Grid } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import Image from '../../../atoms/Image';
import SpecialPriceVariation from './SpecialPriceVariation';
import { getCategoryItems, getCategoryNameFromItems } from '../utils';

class SpecialImage extends React.Component {
  renderContent(item) {
    const { groupByCategory, showImage, categories, precision } = this.props;

    const { name, _id, image, gatsbyImage = {}, description, variations } = item;

    return (
      <div className="special-container">
        {showImage && (
          <Image
            src={image}
            imageQuery={gatsbyImage ? gatsbyImage.childImageSharp : {}}
            className="special-image-carousel-image"
            altText={name}
          />
        )}
        <div className="special-details">
          <h3 className="special-title">{name}</h3>
          {!groupByCategory && (
            <h4 className="special-image-category">{getCategoryNameFromItems(_id, categories)}</h4>
          )}
          <span className="special-description">{description}</span>
          <SpecialPriceVariation variations={variations} precision={precision} />
        </div>
      </div>
    );
  }

  renderWithCategory() {
    const { items, categories } = this.props;

    return (
      <Grid centered stackable columns={3}>
        {getCategoryItems({ items, categories }).map(({ name, items: categoryItems }) => (
          <React.Fragment key={name}>
            <Grid.Column width={16} textAlign="center">
              <h3 className="special-category">{name}</h3>
            </Grid.Column>
            {categoryItems.map(item => (
              <Grid.Column stretched>{this.renderContent(item)}</Grid.Column>
            ))}
          </React.Fragment>
        ))}
      </Grid>
    );
  }

  renderWithoutCategory() {
    const { items } = this.props;

    return (
      <Grid centered stackable columns={3}>
        {items.map(item => (
          <Grid.Column stretched>{this.renderContent(item)}</Grid.Column>
        ))}
      </Grid>
    );
  }

  render() {
    const { groupByCategory, categories } = this.props;

    return groupByCategory && categories.length
      ? this.renderWithCategory()
      : this.renderWithoutCategory();
  }
}

SpecialImage.propTypes = {
  items: PropTypes.array.isRequired,
  categories: PropTypes.array,
  showImage: PropTypes.bool,
  groupByCategory: PropTypes.bool,
};

SpecialImage.defaultProps = {
  categories: [],
  showImage: true,
  groupByCategory: false,
};

export default SpecialImage;
